import React, {useEffect, useState} from 'react';
import {Flex, Image} from "antd";
import Header from "../components/Header/Header";
import BlueButton from "../../components/UI/Buttons/BlueButton";
import DefaultButton from "../../components/UI/Buttons/DefaultButton";
import MyText from "../../components/UI/Text/MyText";
import bannerImg from '../../images/bannerImage.webp';
import Footer from "../components/Footer/Footer";

const HomePage = () => {

    return (
        <Flex style={{width: "100%", position: "relative", paddingLeft: 15, paddingRight: 15}} vertical align={"center"} justify={"flex-start"} gap={50}>
            <Header/>
            <Flex style={{width: "100%", maxWidth: 1440}} vertical align={"center"} justify={"flex-start"} gap={50}>
                <Banner/>
                <InfoItem header={"What is Soundscape?"}
                          body={"Lorem ipsum dolor sit amet, consectetur adipisicing elit. " +
                              "Fugiat hic maiores minima saepe ut. Animi assumenda commodi est " +
                              "laudantium modi mollitia, neque placeat quis tempora ut vel vero " +
                              "voluptate voluptatem. Lorem ipsum dolor sit amet, consectetur adipisicing elit. " +
                              "Fugiat hic maiores minima saepe ut. Animi assumenda commodi est laudantium modi " +
                              "mollitia, neque placeat quis tempora ut vel vero voluptate voluptatem. " +
                              "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat hic " +
                              "maiores minima saepe ut. Animi assumenda commodi est laudantium modi " +
                              "mollitia, neque placeat quis tempora ut vel vero voluptate voluptatem. " +
                              "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat hic " +
                              "maiores minima saepe ut. Animi assumenda commodi est laudantium modi " +
                              "mollitia, neque placeat quis tempora ut vel vero voluptate voluptatem."}/>
                <InfoItem header={"What is Soundscape?"}
                          body={"Lorem ipsum dolor sit amet, consectetur adipisicing elit. " +
                              "Fugiat hic maiores minima saepe ut. Animi assumenda commodi est " +
                              "laudantium modi mollitia, neque placeat quis tempora ut vel vero " +
                              "voluptate voluptatem. Lorem ipsum dolor sit amet, consectetur adipisicing elit. " +
                              "Fugiat hic maiores minima saepe ut. Animi assumenda commodi est laudantium modi " +
                              "mollitia, neque placeat quis tempora ut vel vero voluptate voluptatem. " +
                              "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat hic " +
                              "maiores minima saepe ut. Animi assumenda commodi est laudantium modi " +
                              "mollitia, neque placeat quis tempora ut vel vero voluptate voluptatem. " +
                              "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat hic " +
                              "maiores minima saepe ut. Animi assumenda commodi est laudantium modi " +
                              "mollitia, neque placeat quis tempora ut vel vero voluptate voluptatem."}/>
            </Flex>

            <Footer/>
        </Flex>
    );
};

const Banner = () => {
    return (
        <Flex style={{width: "100%", height: 500, borderRadius: 15, overflow: "hidden", position: "relative"}} align={"center"} justify={"center"}>
            <Image src={bannerImg} preview={false} style={{width: "100%", height: "100%"}} wrapperStyle={{position: "absolute"}}/>
            <div style={{backgroundColor: "#000d1f", opacity: 0.2, width: "100%", height: "100%", position: "absolute"}}></div>
        </Flex>
    )
}

const InfoItem = ({header, body}) => {
    return (
        <Flex style={{width: "100%"}} vertical gap={25} align={"flex-start"} justify={"flex-start"}>
            <MyText strong size={"large"}>
                {header}
            </MyText>
            <MyText>
                {body}
            </MyText>
        </Flex>
    )
}
export default HomePage;